import { endOfMonth, isAfter, isBefore, startOfMonth } from "date-fns";

import languageMap from "@utils/languageMap";

import { TMonth } from "../types";

type TDateFilters = {
  selectedYear?: number;
  minDate?: Date;
  maxDate?: Date;
};

const getMonthName = (date: Date, locale?: string | undefined): string => {
  if (!locale) {
    const month = date.getMonth() + 1;
    return month < 10 ? `0${month}` : month.toString();
  }

  return date.toLocaleString(locale, { month: "long" });
};

/**
 *
 * @param locale if locale is set, date name will be locale string
 * @param filters object of selectedYear (number), minDate and maxDate to filter possible months
 * @returns an array of objects with name and value keys. Value is a month index starting with 0.
 * Name is either a date number ranging from 01 to 12 or a locale string.
 */
const getMonths = (locale?: string | undefined, filters?: TDateFilters): TMonth[] => {
  const months = Array.from({ length: 12 }, (_, index) => {
    const date = new Date();
    date.setDate(1);
    date.setMonth(index);

    const name = getMonthName(date, locale ? languageMap[locale] : locale);
    return { name, value: index };
  });

  const selectedYear = filters?.selectedYear;
  const minDate = filters?.minDate;
  const maxDate = filters?.maxDate;

  if (!selectedYear || (!minDate && !maxDate)) {
    return months;
  }

  const filteredMonths = months.filter(({ value }) => {
    const monthDate = new Date(selectedYear, value, 1);
    const isBeforeMinDate = minDate && isBefore(monthDate, startOfMonth(minDate));
    const isAfterMaxDate = maxDate && isAfter(monthDate, endOfMonth(maxDate));

    return !isBeforeMinDate && !isAfterMaxDate;
  });

  return filteredMonths;
};
export default getMonths;
